import React, { useState, useEffect } from "react";
import { Table, Button, Input, Space, Tooltip, message, Modal } from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import AccountPopup from "../../component/dashboard/AccountPopupCompo";
import HeaderCompo from "../../component/Header";
import { axiosInstance } from "../../utils/axiosInterceptor";
import Chat from "../../components/chats/Chat";
import { useSelector } from "react-redux";

const Accounts = () => {
  const [loading, setLoading] = useState(false);
  // const [accounts, setAccounts] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);  
  const [chatBoxOpen, setChatOpen] = useState(false)
  
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [allAccounts, setAllAccounts] = useState([]); // Add this state for storing all accounts
  const [filteredAccounts, setFilteredAccounts] = useState([]); // Add this for filtered data
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);

  const fetchAccounts = async (page = 1, pageSize = 10) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      // console.log(token, "tokensnsnns")
      const response = await axiosInstance.get(
        `/api/v2/account/all-accounts?skip=${(page - 1) * pageSize
        }&take=${pageSize}&requireTotalCount=true`,
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      );
      const data = response?.data?.data;
      // console.log(response, "response in account")
      setAllAccounts(data);
      setFilteredAccounts(data);
      setPagination({
        ...pagination,
        total: response.data.total,
        current: page,
        pageSize: pageSize,
      });
    } catch (error) {
      // message.error("Failed to fetch accounts");
      console.error("Error fetching accounts:", error);
    } finally {
      setLoading(false);
    }

  };



  const handleSearch = (value) => {
    setSearchText(value);
    const searchVal = value.toLowerCase();
    const filtered = allAccounts.filter(
      (account) =>
        account.name?.toLowerCase().includes(searchVal) ||
        account.city?.toLowerCase().includes(searchVal) ||
        account.state?.toLowerCase().includes(searchVal) ||
        account.acct_id?.toString().includes(searchVal)
    );
    setFilteredAccounts(filtered);
    setPagination({
        ...pagination,
        total: filtered?.length,
        current: 1,
        pageSize: 10,
      });
  };
  const columns = [
    {
      title: "Account Number",
      dataIndex: "acct_id",
      key: "acct_id",
      width: "15%",
      sorter: (a, b) => a.acct_id - b.acct_id,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "20%",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: "15%",
      sorter: (a, b) => (a.city || "").localeCompare(b.city || ""),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      width: "15%",
      sorter: (a, b) => (a.state || "").localeCompare(b.state || ""),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "15%",
      sorter: (a, b) => a.status - b.status,
      render: (status, record) => (record.active ? "Active" : "Inactive"),
    },
    {
      title: "Actions",
      key: "actions",
      width: "10%",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit Account">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Tooltip title="Edit Account">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record.id)}
              danger
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
  const handleTableChange = (newPagination) => {
    fetchAccounts(newPagination.current, newPagination.pageSize, searchText);
  };
  const handleEdit = (record) => {
    setSelectedAccount(record);
    setPopupVisible(true);
  };
  const handleDelete = async (userId) => {
    Modal.confirm({
      title: "Delete Account",
      content: "Are you sure you want to delete this account?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      okButtonProps: {
        style: {
          float: "left",
        },
      },
      cancelButtonProps: {
        style: {
          float: "right",
        },
      },
      onOk: async () => {
        try {
          const token = localStorage.getItem("token");
          await axiosInstance.delete(`/account/${userId}`, {
            // headers: {
            //   "Content-Type": "application/json",
            //   Authorization: `Bearer ${token}`,
            // },
          });
          message.success("Account deleted successfully");
          fetchAccounts();
        } catch (error) {
          message.error(
            error.response?.data?.message || "Failed to delete account"
          );
          console.error("Error deleting account:", error);
        }
      },
    });
  };
  const handleAdd = () => {
    setSelectedAccount(null);
    setPopupVisible(true);
  };

  useEffect(() => {
    fetchAccounts(pagination.current, pagination.pageSize, searchText);
  }, []);




  // const handleSearch = (value) => {
  //   setSearchText(value);
  //   fetchAccounts(1, pagination.pageSize, value);
  // };

  return (
    // <Layout className="layout">
    <>
      <HeaderCompo initialColor={'#000833'} />

      <div className="p-4">
        <div
          className="flex md:items-center md:justify-between  flex-col md:flex-row gap-4 mb-4 px-4 pt-4"
          style={{ padding: "16px 16px 0 16px" }}
        >
          <h1 className="text-2xl font-bold">Account Management</h1>
          <div className="flex sm:flex-row gap-2 w-full md:w-auto">
            <Input
              placeholder="Search by Account name / Number..."
              prefix={<SearchOutlined />}
              onChange={(e) => handleSearch(e.target.value)}
            className="w-[90%] sm:w-[250px] "
              style={{
                border: "1px solid var(--Primary-Dark-Blue, #000833)",
                // width: 250,
                height: "40px",
              }}
              allowClear
            />

            <Tooltip title="Add New Account">
              <Button
                type="primary"
                icon={<UserAddOutlined />}
                onClick={handleAdd}
                style={{ height: "40px" }}
              />
            </Tooltip>
          </div>
          {/*         
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAdd}
            className="bg-[#0EA5E9]"
          >
            Add Account
          </Button> */}
        </div>

        <Table
          columns={columns}
          dataSource={filteredAccounts}
          rowKey="acct_id"
          pagination={{
            pageSize:pagination?.pageSize,
            showSizeChanger: true,
            showTotal: (total) => `Total ${pagination?.total} accounts`,
          }}
          onChange={handleTableChange}
          loading={loading}
          scroll={{ x: 1000 }}
          className="custom-table user-tbl"
        />
         {/* {userAuth?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
                <div className="chat-button-new" onClick={() => setChatOpen(true)}>
                  💬 Let’s Chat
                </div>
              )} */}
              <Chat
                      open={chatBoxOpen}
                      setOpen={setChatOpen}
                    />
        <AccountPopup
          popupWithScrollViewVisible={popupVisible}
          hide={() => setPopupVisible(false)}
          data={selectedAccount}
          isNewRecord={!selectedAccount}
          onSuccess={() => {
            fetchAccounts(pagination.current, pagination.pageSize, searchText);
            setPopupVisible(false);
          }}
        />
      </div>
    </>
    // </Layout>
  );
};

export default Accounts;
